export default {
	home:{
		contact: 'Contato',
		contact_us: 'Contate-nos',
		text: 'Grandes Novidades Chegando! Vamos Inovar Juntos!'
	},
	contact:{
		name: 'Nome',
		email: 'E-mail',
		number: 'Número de Telefone',
		message: 'Mensagem',
		send: 'Enviar',
		back: 'Voltar'
	},
	notifications:{
		title_success: 'Pronto!',
		error_title: 'Há problemas no formulário!',
		message_success: 'Obrigado pelo contato! Responderemos em breve.',

		error:{
			name: 'O nome é obrigatório!',
			email: 'O e-mail é obrigatório!',
			email_wrong: 'O e-mail inserido é inválido',
			number: 'O número de telefone é obrigatório!',
			message: 'A mensagem é obrigatória!'
		}
	}
}


// WEBPACK FOOTER //
// ./src/messages/pt.js